<ng-container>
  <ng-template #itemsList>
    <div *ngFor="let item of inKindItemsForDisplay"
      class="item-line">
      <div class="left-side">
        {{ item.count }}
        {{ allItemsMap[item.itemIdentification]?.name || item.itemIdentification }}
      </div>
      <div *ngIf="isManager">
        {{ ((allItemsMap[item.itemIdentification].value) * item.count) | gcMoney }}
      </div>
    </div>
  </ng-template>

  <button #numberOfUnitsLink="bs-popover" 
    class="btn btn-link p-0 text-left"
    [class.font-550]="amountIsBold"
    [placement]="popoverPlacement"
    [class.text-right]="alignRight"
    [popover]="itemsList"
    [popoverContext]="{
      numberOfUnitsLink: numberOfUnitsLink
    }"
    [outsideClick]="true"
    (click)="showPopover()">
    <yc-i18n class="text-link"
      key="GLOBAL:textNumberUnits"
      [context]="{
        number: inKindItems ?
          ((inKindItems | gcInKindNumberOfUnits) | number) :
          inKindItemTotalCount
      }"
      defaultValue="__number__ units">
    </yc-i18n> 
    <ng-container *ngIf="(amount || amount === 0) && isManager">
      <div *ngIf="unitsOnNewLine">
        {{ amount | gcMoney: defaultCurrency: true}}
      </div>
      <ng-container *ngIf="!unitsOnNewLine">
        ({{ amount | gcMoney: defaultCurrency: true}})
      </ng-container>
    </ng-container>
  </button>
</ng-container>
